module.exports = __webpack_public_path__ + "img/floor_f14_02.9a9926ea.png";